import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { UpdatedDate } from '@/components/LoanTerms/UpdatedDate';
import { LAST_UPDATE } from './constants';
import Icon from './assets/icon_check.svg';
import IconSettings from './assets/icon_settings.svg';
import IconAlert from './assets/icon_alert.svg';
import IconCalendar from './assets/icon_calendar.svg';
import s from './index.module.scss';

const FlexibilityPageV1 = () => {
  const { t } = useTranslation('flexibility');

  const IconCheck = <img src={Icon} alt="icon" width={20} height={20} />;

  return (
    <div className={s.wrapper}>
      <div className="container-inner">
        <h1 className="f-hero-h2">{t('flexibility_page.title')}</h1>
        <p className={classnames('f-paragraph-regular', s.subtitle)}>
          {t('flexibility_page.subtitle')}
        </p>
        <div className={s.content}>
          <div className="f-body-regular">{t('flexibility_page.description')}</div>
          <div className={s.pricing}>
            <div className="f-hero-h4">{t('flexibility_page.pricing_title')}</div>
            <div className={s.pricing_content}>
              <div className={s.pricing_row}>
                <div>
                  <div className="f-body-accent">{t('flexibility_page.upfront_fee_title')}</div>
                  <div className="f-body-regular">
                    {t('flexibility_page.upfront_fee_description')}
                  </div>
                </div>
                <div className="f-hero-h5">{t('flexibility_page.upfront_fee_value')}</div>
              </div>
              <div className={s.pricing_row}>
                <div>
                  <div className="f-body-accent">{t('flexibility_page.per_shift_fee_title')}</div>
                  <div className="f-body-regular">
                    {t('flexibility_page.per_shift_fee_description')}
                  </div>
                </div>
                <div className="f-hero-h5">{t('flexibility_page.per_shift_fee_value')}</div>
              </div>
              <div className={classnames(s.pricing_summary, 'f-body-regular')}>
                {t('flexibility_page.fees_note')}
              </div>
            </div>
          </div>
          <div className={s.how}>
            <div className="f-hero-h4">{t('flexibility_page.how_it_helps_title')}</div>
            <div>
              <ul className={classnames('f-body-regular', s.how_list)}>
                <li>
                  {IconCheck} {t('flexibility_page.how_it_helps_avoid_penalties')}
                </li>
                <li>
                  {IconCheck} {t('flexibility_page.how_it_helps_protect_cash_flow')}
                </li>
                <li>
                  {IconCheck} {t('flexibility_page.how_it_helps_good_standing')}
                </li>
                <li>
                  {IconCheck} {t('flexibility_page.how_it_helps_shift_payments')}
                </li>
                <li>
                  {IconCheck} {t('flexibility_page.how_it_helps_pay_when_use')}
                </li>
              </ul>
            </div>
          </div>
          <div className={s.notes}>
            <div className="f-hero-h4">{t('flexibility_page.important_notes_title')}</div>
            <div className={s.notes_cards}>
              <div className={s.notes_card}>
                <div className={s.notes_icon}>
                  <img src={IconSettings} alt="calendar" width={24} height={24} />
                </div>
                <div className="f-body-regular">{t('flexibility_page.note_add_flexibility')}</div>
              </div>
              <div className={s.notes_card}>
                <div className={s.notes_icon}>
                  <img src={IconCalendar} alt="calendar" width={24} height={24} />
                </div>
                <div className="f-body-regular">{t('flexibility_page.note_payment_transfer')}</div>
              </div>
              <div className={s.notes_card}>
                <div className={s.notes_icon}>
                  <img src={IconAlert} alt="calendar" width={24} height={24} />
                </div>
                <div className="f-body-regular">{t('flexibility_page.note_missed_payment')}</div>
              </div>
            </div>
          </div>
          <UpdatedDate className={s.update} date={LAST_UPDATE} />
        </div>
      </div>
    </div>
  );
};

export default FlexibilityPageV1;
